var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCaret(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "#525252"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 14.071l6.364-6.364a1 1 0 011.414 0l6.364 6.364",
    strokeLinecap: "round"
  })));
}

export default "data:image/svg+xml;base64,bW9kdWxlLmV4cG9ydHMgPSAiZGF0YTppbWFnZS9zdmcreG1sO2Jhc2U2NCxQSE4yWnlCM2FXUjBhRDBpTmpSd2VDSWdhR1ZwWjJoMFBTSTJOSEI0SWlCMmFXVjNRbTk0UFNJd0lEQWdNalFnTWpRaUlHWnBiR3c5SW01dmJtVWlJSGh0Ykc1elBTSm9kSFJ3T2k4dmQzZDNMbmN6TG05eVp5OHlNREF3TDNOMlp5SWdjM1J5YjJ0bFBTSWpOVEkxTWpVeUlqNEtJQ0E4WnlCcFpEMGlVMVpIVW1Wd2IxOWlaME5oY25KcFpYSWlJSE4wY205clpTMTNhV1IwYUQwaU1DSStQQzluUGdvZ0lEeG5JR2xrUFNKVFZrZFNaWEJ2WDNSeVlXTmxja05oY25KcFpYSWlJSE4wY205clpTMXNhVzVsWTJGd1BTSnliM1Z1WkNJZ2MzUnliMnRsTFd4cGJtVnFiMmx1UFNKeWIzVnVaQ0krUEM5blBnb2dJRHhuSUdsa1BTSlRWa2RTWlhCdlgybGpiMjVEWVhKeWFXVnlJajRLSUNBZ0lEeHdZWFJvSUdROUlrMDFJREUwTGpBM01URk1NVEV1TXpZMElEY3VOekEzTVRGRE1URXVOelUwTlNBM0xqTXhOalU0SURFeUxqTTROemNnTnk0ek1UWTFPQ0F4TWk0M056Z3lJRGN1TnpBM01URk1NVGt1TVRReU1TQXhOQzR3TnpFeElpQnpkSEp2YTJVOUlpTTFNalV5TlRJaUlITjBjbTlyWlMxc2FXNWxZMkZ3UFNKeWIzVnVaQ0krUEM5d1lYUm9QZ29nSUR3dlp6NEtQQzl6ZG1jKyI=";
export { SvgCaret as ReactComponent };